import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons'
import { Anchor, Box, type BoxProps, Checkbox, Flex, Text } from '@mantine/core'
import {  useDisclosure } from '@mantine/hooks'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

import { useStoreCategories } from '../../hooks/useStoreCategories'
import styles from './styles.module.css'
import { useProductListFilters } from './useProductListFilters'

const LIMIT_CATEGORIES_TO_SHOW = 15

export function FilterCategories(props: BoxProps) {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-product-list',
  })

  const [opened, handlers] = useDisclosure(false)
  const { filters, setFilter } = useProductListFilters()

  const categories = useStoreCategories()
  const diffCountCategories = categories.length - LIMIT_CATEGORIES_TO_SHOW

  return (
    <Box {...props}>
      <Text fw={500} mb='sm'>
        {t('label_categories')}
      </Text>
      <Box className={styles.itemCategories}>
        {categories
          .slice(0, opened ? categories.length : LIMIT_CATEGORIES_TO_SHOW)
          .map((c) => {
            const isChecked = filters.category_ids?.includes(Number(c.id))

            return (
              <Checkbox
                key={c.id}
                size='xs'
                checked={isChecked}
                label={
                  <Text size='sm' mt={-1}>
                    {c.name}
                  </Text>
                }
                onClick={() => {
                  const categoryIds = isChecked
                    ? filters.category_ids?.filter(
                        (id) => Number(id) !== Number(c.id)
                      )
                    : [...(filters.category_ids ?? []), Number(c.id)]

                  setFilter('category_ids', categoryIds)
                }}
              />
            )
          })}
        {diffCountCategories >= 1 && (
          <Anchor onClick={handlers.toggle} size='sm' ml='xs'>
            <Flex align='center' gap='xs'>
              <Icon icon={opened ? faChevronUp : faChevronDown} size='xs' />
              {opened ? t('label_show_less') : t('label_show_more')}
            </Flex>
          </Anchor>
        )}
      </Box>
    </Box>
  )
}
